export default __webpack_public_path__ + "static/media/OpenSeaLogo.9e66531d.svg";